/**
 * Presets for the RoundingDpComponent.
 *
 * The component is self-contained (it manages its own internal signals for
 * value and dp) and does not accept params as an input. These presets capture
 * representative initial states that can be used to document the widget or
 * seed its internal state via the study-notes editor.
 */

export interface RoundingDpPresetState {
  readonly value: number;
  readonly dp: number;
}

export const ROUNDING_DP_DEFAULT: RoundingDpPresetState = {
  value: 7.3482,
  dp: 2,
};

export const ROUNDING_DP_ROUND_UP: RoundingDpPresetState = {
  value: 3.4567,
  dp: 2,
};

export const ROUNDING_DP_ROUND_DOWN: RoundingDpPresetState = {
  value: 8.1234,
  dp: 1,
};

export const ROUNDING_DP_ZERO_DP: RoundingDpPresetState = {
  value: 14.782,
  dp: 0,
};

export const ROUNDING_DP_MANY_DECIMALS: RoundingDpPresetState = {
  value: 0.00347,
  dp: 4,
};

export const ROUNDING_DP_NEGATIVE: RoundingDpPresetState = {
  value: -3.6789,
  dp: 2,
};

export const ROUNDING_DP_PRESETS: Record<string, Record<string, unknown>> = {
  default: { params: ROUNDING_DP_DEFAULT },
  'round-up': { params: ROUNDING_DP_ROUND_UP },
  'round-down': { params: ROUNDING_DP_ROUND_DOWN },
  'zero-dp': { params: ROUNDING_DP_ZERO_DP },
  'many-decimals': { params: ROUNDING_DP_MANY_DECIMALS },
  negative: { params: ROUNDING_DP_NEGATIVE },
};
